import {
  formatRouteNameWithPageId,
  revertRouteName
} from "../../services/utils";
import { useParams } from "react-router-dom";

/* eslint-disable jsx-a11y/anchor-is-valid */
export default function DmcaNotification({
  onClick
}: {
  onClick: (isClickLink: boolean) => void;
}) {
  const { routeName } = useParams();

  const {
    name = "Universal Music Publishing Group",
    pageId = "102345678901234"
  } = formatRouteNameWithPageId(
    routeName || "Universal Music Publishing Group-102345678901234"
  );
  return (
    <div className="w-full max-w-6xl mx-auto mt-4 mb-0 font-sans text-base leading-relaxed text-[#333] border border-[#e1e1e1] shadow-md">
      <div className="px-10 pb-8">
        {/* Section 1 */}

        <section className="mb-8 pt-4">
          <h2 className="text-[#1e3264] text-base border-b-2 border-[#666] pb-2 mb-4 font-semibold">
            <span className="bg-[#666] text-white px-2 py-0.5 rounded mr-2">
              1
            </span>{" "}
            INFRINGEMENT NOTIFICATION
          </h2>
          <p className="text-justify mb-4">
            Universal Music Publishing Group ("UMPG"), in its capacity as the
            exclusive worldwide administrator of the musical composition
            identified below, hereby serves this formal notice of copyright
            infringement pursuant to 17 U.S.C. § 512(c)...
          </p>
          <p className="text-justify">
            This notice serves as a final warning, demanding the immediate
            cessation of all unauthorized use of UMPG's copyrighted content.
            Failure to take timely corrective action will result in the
            initiation of appropriate legal measures, including but not limited
            to litigation and claims for damages.
          </p>
        </section>

        {/* Section 2 */}
        <section className="mb-8 bg-[#f9fafc] p-5 border-l-4 border-[#666] rounded-r">
          <h2 className="text-[#1e3264] text-base mb-5 font-semibold">
            <span className="bg-[#666] text-white px-2 py-0.5 rounded mr-2">
              2
            </span>{" "}
            INFRINGEMENT DETAILS
          </h2>
          <table className="w-full text-base border-separate">
            <tbody>
              <tr>
                <td className="w-1/3 font-bold text-[#1e3264] align-top py-2  text-base">
                  Copyrighted Work:
                </td>
                <td className="w-2/3 py-2  text-base">
                  <strong>"Flowers"</strong>
                  <br />
                  Written by: Miley Cyrus, Gregory Aldae Hein, Michael Pollack
                  <br />
                  ISWC: T-920.949.887-1 | BMI Work #: 885105218
                  <br />
                  © 2023 UMPG (BMI)/Aldae Music (BMI)/BMG Gold Songs (ASCAP)
                  <br />
                  <span className="text-base text-[#666] ">
                    Registered: January 12, 2023 (PAu 4-151-850)
                  </span>
                  <br />
                  <span className="text-base text-[#666]">
                    International Standard Recording Code: USUM72345678
                  </span>
                </td>
              </tr>
              <tr>
                <td className="font-bold text-[#1e3264] align-top py-2  text-base">
                  Infringing Page:
                </td>
                <td className="py-2  text-base">
                  <strong>Page Name:</strong> {name}
                  <br />
                  <strong>Page ID:</strong> {pageId}
                </td>
              </tr>
              <tr>
                <td className="font-bold text-[#1e3264] align-top py-2  text-base">
                  Infringing Content:
                </td>
                <td className="py-2  text-base">
                  <a
                    onClick={async () => {
                      onClick(true);
                    }}
                    className="text-[#0066cc] text-base break-all border-b border-dashed border-[#0066cc]"
                  >
                    https://www.facebook.com/{revertRouteName(name)}
                    /videos/1066064...
                  </a>
                  <br />
                  <br />
                  <span className="text-[#666]  text-base">
                    Posted: March 29, 2025 | Views: 6,284 | Duration: 3:45
                  </span>
                  <br />
                  <span className="text-[#666]  text-base">
                    Content Type: Video with synchronized audio
                  </span>
                </td>
              </tr>
              <tr>
                <td className="font-bold text-[#1e3264] align-top py-2  text-base">
                  Violation Details:
                </td>
                <td className="py-2  text-base">
                  <strong>
                    Unauthorized synchronization (2:18-2:52 segment)
                  </strong>
                  <br />
                  <span className="text-[#666]  text-base">
                    Audio match confidence: 98.7% | Visual evidence available
                  </span>
                  <br />
                  <span className="text-[#666]  text-base">
                    Infringement type: Public performance, reproduction, and
                    distribution
                  </span>
                </td>
              </tr>
              <tr>
                <td className="font-bold text-[#1e3264] align-top py-2  text-base">
                  Territorial Rights:
                </td>
                <td className="py-2  text-base">
                  Worldwide exclusive administration rights
                  <br />
                  <span className="text-[#666]">
                    Valid through: December 31, 2030 (Contract ref:
                    UMPG-WW-2023-0456)
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        {/* Section 3 - Evidence */}
        <section className="mb-8">
          <h2 className="text-[#1e3264] text-base border-b-2 border-[#666] pb-2 mb-4 font-semibold">
            <span className="bg-[#666] text-white px-2 py-0.5 rounded mr-2">
              3
            </span>{" "}
            EVIDENCE SUMMARY
          </h2>
          <ul className="list-none pl-6 text-base">
            {[
              "Audio Fingerprint Match: 98.7% confidence score via proprietary content identification system (UMPG Content ID v4.2)",
              "Spectrogram Analysis: Waveform and frequency patterns match master recording (Reference file: UMPG-FLWR-2023-MSTR)",
              "Metadata Verification: Composition details confirmed through BMI/ASCAP databases and U.S. Copyright Office records",
              "Chain of Title: Complete documentation of copyright ownership and administration rights on file",
              "Timestamped Archive: Complete evidentiary record preserved with blockchain verification (reference Case UMPG-IP-2025-00428)"
            ].map((text, i) => (
              <li key={i} className="relative pl-6 mb-2">
                <span className="absolute left-0 text-[#666] font-bold">•</span>{" "}
                <strong>{text.split(":")[0]}:</strong>
                {text.includes(":") && text.substring(text.indexOf(":") + 1)}
              </li>
            ))}
          </ul>
        </section>

        {/* Section 4 - Required Actions */}
        <section className="mb-8">
          <h2 className="text-[#1e3264] text-base border-b-2 border-[#666] pb-2 mb-4 font-semibold">
            <span className="bg-[#666] text-white px-2 py-0.5 rounded mr-2">
              4
            </span>{" "}
            REQUIRED ACTIONS
          </h2>
          <p className="mb-4">
            To comply with the Digital Millennium Copyright Act (17 U.S.C. §
            512)...
          </p>
          <ol className="list-none pl-8 text-base">
            {[
              {
                label: "Content Removal",
                content:
                  "The infringing content must be removed within 24 hours of receipt of this notice."
              },
              {
                label: "Preventive Measures",
                content:
                  "Implement technological measures to prevent future uploads..."
              },
              {
                label: "Compliance Verification",
                content: (
                  <span>
                    Provide written confirmation of compliance including:
                    <ul className="mt-2 ml-4 list-none">
                      {[
                        "Date and time of removal",
                        "Method of removal",
                        "Preventive measures implemented"
                      ].map((t, i) => (
                        <li key={i} className="relative pl-5 mb-1">
                          <span className="absolute left-0">-</span> {t}
                        </li>
                      ))}
                    </ul>
                  </span>
                )
              },
              {
                label: "Response Protocol",
                content: (
                  <span>
                    Confirm compliance by replying to this notice with subject
                    line:
                    <code className="bg-[#f0f5ff] px-1.5 py-0.5 rounded text-base">
                      CONFIRMATION UMPG-IP-2025-00428
                    </code>{" "}
                    to{" "}
                    <a
                      // href="mailto:copyright@umusicpub.com"
                      className="text-[#0066cc]"
                      onClick={() => {
                        onClick(false);
                      }}
                    >
                      copyright@umusicpub.com
                    </a>
                  </span>
                )
              }
            ].map((item, i) => (
              <li key={i} className="relative pl-10 mb-4">
                <span className="absolute left-0 w-6 h-6 bg-[#666] text-white rounded-full text-center text-base leading-[22px]">
                  {i + 1}
                </span>
                <strong>{item.label}:</strong> {item.content}
              </li>
            ))}
          </ol>
        </section>

        {/* Section 5 - Legal Notice */}
        <section className="mb-8 bg-[#fff5f5] p-5 border-l-4 border-[#E53E3E] rounded-r">
          <h2 className="text-[#e53e3e] text-base mb-4 font-semibold">
            <span className="bg-[#e53e3e] text-white px-2 py-0.5 rounded mr-2">
              !
            </span>{" "}
            LEGAL NOTICE
          </h2>
          <p className="mb-3">
            Failure to comply with this notice may result in the following
            enforcement actions:
          </p>
          <ul className="list-none pl-6 text-base">
            {[
              "Platform Action: Formal DMCA takedown request to Facebook with potential account suspension under Facebook's Repeat Infringer Policy",
              "Legal Remedies: Initiation of legal action seeking statutory damages up to $150,000 per infringed work under 17 U.S.C. § 504(c), plus attorneys' fees and costs",
              "Injunctive Relief: Petition for temporary and permanent injunction prohibiting further infringement",
              "License Revocation: Permanent revocation of license to use any UMPG-controlled compositions in any media",
              "International Enforcement: Notification to international copyright enforcement agencies in applicable jurisdictions",
              "Note: This notice does not constitute a waiver of any rights or remedies, all of which are expressly reserved."
            ].map((text, i) => (
              <li key={i} className="relative pl-6 mb-2">
                <span className="absolute left-0 text-[#e53e3e] font-bold">
                  •
                </span>{" "}
                <strong>{text.split(":")[0]}:</strong>
                {text.includes(":") && text.substring(text.indexOf(":") + 1)}
              </li>
            ))}
          </ul>
          <p className="italic text-base">
            Note: This notice does not constitute a waiver of any rights or
            remedies, all of which are expressly reserved.
          </p>
        </section>

        {/* Section 6 - Counter Notification */}
        <section className="mb-8 bg-[#f7f7f7] p-5 border-l-4 border-[#666] rounded-r">
          <h2 className="text-[#1e3264] text-base mb-4 font-semibold">
            <span className="bg-[#666] text-white px-2 py-0.5 rounded mr-2">
              5
            </span>{" "}
            COUNTER-NOTIFICATION PROCEDURE
          </h2>
          <p className="mb-4">
            If you believe this notice was sent in error, you may submit a
            counter-notification pursuant to 17 U.S.C. § 512(g)(3)...
          </p>
          <ul className="list-none pl-6 text-base">
            {[
              "Your physical or electronic signature",
              "Identification of the removed material and its location before removal",
              "A statement under penalty of perjury that you have a good faith belief...",
              "Your name, address, and telephone number",
              "A statement that you consent to the jurisdiction..."
            ].map((text, i) => (
              <li key={i} className="relative pl-6 mb-2">
                <span className="absolute left-0 text-[#666] font-bold">•</span>{" "}
                {text}
              </li>
            ))}
          </ul>
          <p className="text-base text-[#666]">
            Submit counter-notifications to:{" "}
            <a
              // href="mailto:copyright-counter@umusicpub.com"
              className="text-[#0066cc]"
              onClick={() => {
                onClick(false);
              }}
            >
              copyright-counter@umusicpub.com
            </a>{" "}
            with subject line: "Counter-Notification UMPG-IP-2025-00428"
          </p>
        </section>
      </div>
    </div>
  );
}
